import React from 'react';

const MonthsAccountsPage = () => {
  return <div>월별 결산</div>;
};

export default MonthsAccountsPage;
